import { I } from '@angular/cdk/keycodes';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { KEYS } from '@pos-app/data';

@Component({
  selector: 'app-iframe-base',
  styleUrls: ['./iframe-base.component.scss'],
  templateUrl: './iframe-base.component.html',
})
export class IframeBaseComponent implements OnInit {
  @Input() iframeAppName: string;
  @Input() show;
  public iframeUrl: any = null;
  public showIframe = false;
  loading: boolean;
  constructor(private sanitizer: DomSanitizer) {}
  helpComponentUrl = JSON.parse(localStorage.getItem(KEYS.jdeSession)).iframeBaseUrl;

  ngOnInit() {
    this.loadIframe();
  }

  public loadIframe(): void {
    this.loading = true;

    this.iframeUrl = this.transform(this.helpComponentUrl);
    this.iFrameAssignment(true);
  }
  public transform(url): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public iFrameAssignment(isVisible: boolean): void {
    this.showIframe = isVisible;
    this.isScrollBar();
  }

  public isScrollBar(): void {
    if (this.showIframe) {
      document.documentElement.style.setProperty('--main-scrollbar-width', '0');
      document.documentElement.style.setProperty('--main-scrollbar-height', '0');
    } else {
      document.documentElement.style.setProperty('--main-scrollbar-width', '17px');
      document.documentElement.style.setProperty('--main-scrollbar-height', '17px');
    }
  }

  onIframeLoad() {
    console.log('Iframe loaded');
    this.loading = false;
  }
}
